export function isTomorrow(date, timeTravelOverride) {
    const tomorrow = timeTravelOverride ? new Date(timeTravelOverride) : new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return (date.getDate() === tomorrow.getDate() &&
        date.getMonth() === tomorrow.getMonth() &&
        date.getFullYear() === tomorrow.getFullYear());
}
//# sourceMappingURL=isTomorrow.js.map